var map = {
	"./poppy_1.jpeg": 5780,
	"./poppy_10.jpeg": 2527,
	"./poppy_2.jpeg": 5554,
	"./poppy_3.jpeg": 8070,
	"./poppy_4.jpeg": 7570,
	"./poppy_5.jpeg": 3921,
	"./poppy_6.jpeg": 2358,
	"./poppy_7.jpeg": 5352,
	"./poppy_8.jpeg": 3392,
	"./poppy_9.jpeg": 2240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9829;